const qscoinprice = [
  {
    itemid: "itm_coins500k",
    name: "500K Coins",
    amount: 500000,
    currency: "cur_pixel",
    price: 30,
    image: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_coin_coupon/e1a95250-31ac-45b7-927d-809166026368.png",
  },
  {
    itemid: "itm_coins1m",
    name: "1M Coins",
    amount: 1000000,
    currency: "cur_pixel",
    price: 56,
    image: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_coupon_coupon_2/0fac9599-d963-4fc7-9ae5-ef49125a9c64.png",
  },
  {
    itemid: "itm_coins4m",
    name: "4M Coins",
    amount: 4000000,
    currency: "cur_pixel",
    price: 195,
    image: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_coupon_coupon_3/ed131a1c-411a-4554-a044-2442411abe33.png",
  },
  {
    itemid: "itm_quick1",
    name: "1 Quicksilver",
    amount: 1,
    currency: "cur_pixel",
    price: 0.15,
    image: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_speedup_copon/b7ef50f3-c395-449c-a81f-86c29f292dab.png",
  },
  {
    itemid: "itm_quick120",
    name: "60 Quicksilver",
    amount: 60,
    currency: "cur_pixel",
    price: 9,
    image: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_speedupbundle1/b49de7bd-6ac8-48e0-a440-6749c2fdfb7c.png",
  },
  {
    itemid: "itm_quick675",
    name: "186 Quicksilver",
    amount: 186,
    currency: "cur_pixel",
    price: 23,
    image: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_speedupbundle2/ead0dc7d-6025-46c1-8ba9-7edcff59e33f.png",
  },
  {
    itemid: "itm_quick3k",
    name: "1,440 Quicksilver",
    amount: 1440,
    currency: "cur_pixel",
    price: 145,
    image: "https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_speedupbundle3/224952c2-a337-4f14-ba1c-bb661da48d50.png",
  },
];

module.exports = qscoinprice;
